import { GobernanzaSessionService } from "@modules/gobernanza/services/gobernanza-session.service";

import {
  type HttpHandlerFn,
  type HttpInterceptorFn,
  type HttpRequest,
} from "@angular/common/http";
import { inject } from "@angular/core";

const GOVERNANCE_API_PATH = "/api/governance/";

export const gobernanzaInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  if (!req.url.includes(GOVERNANCE_API_PATH)) {
    return next(req);
  }

  const sessionService = inject(GobernanzaSessionService);
  const token = sessionService.accessToken();

  const modifiedReq = token
    ? req.clone({
        headers: req.headers.set("Authorization", `Bearer ${token}`),
      })
    : req.clone({ headers: req.headers.delete("Authorization") });

  return next(modifiedReq);
};
